import { NavigationGuard, NavigationGuardNext, Route } from "vue-router";
import store from "@/store";
import * as types from "../store/types";
import appbaseStore from "@appbase/store";
import * as msTeams from "@microsoft/teams-js";
import { LoginActionPayload } from "../store/actions";

//
// ──────────────────────────────────────────────────── I ──────────
//   :::::: C O M M O N : :  :   :    :     :        :          :
// ──────────────────────────────────────────────────────────────
//

const BYPASS_NAMES = ['account-login', 'redirect-page', 'error-page', 'not-authorized'];
const checkAccessTree = (menu: account.TPermissionMenu, menuList: account.TPermissionMenu[]): boolean => {
    let parentMenu = menuList.find(m => m.id === menu.parentId);

    if(parentMenu) {
        console.log('menu-parent-r', parentMenu.id, parentMenu.r);
        if(parentMenu.parentId == null || parentMenu.parentId == 0) {
            return true;
        } else {
            return parentMenu.r && checkAccessTree(parentMenu, menuList);
        }        
    } else {
        return menu.parentId == null || menu.parentId == 0;
    }
}

/**
 * 인증 상태를 확인합니다.
 */
const authenticated = (): boolean => {
    var current = store.state.$account?.current;
    return current !== null;
};

/**
 * 인증 상태를 확인합니다.
 */
const accessable = (to: Route): boolean => {
    let { MENUID } = to.query;

    if(MENUID) {        
        let toId = Number(MENUID.toString());
        let current = store.state.$account?.current;
        let menuItem = current?.permissions.menues.find(m => m.id === toId);

        let superAdmin: boolean = current?.permissions.isSuperAdmin || false;
        let menuAdmin: boolean = menuItem?.manager ||false;

        if(superAdmin || menuAdmin)
            return true;

        if(menuItem) {
            console.log('menu-r', menuItem.id, menuItem.r);
            return menuItem.r && checkAccessTree(menuItem, current?.permissions.menues || []);
        } 

        return false;
    } 
            
    return true;
};


/**
 * 로그인 상태가 아닌경우, 이메일 주소만으로 로그인 처리합니다.
 * @param email 로그인할 이메일 주소
 * @returns true: 로그인 또는 토큰 정상, false: 인증 실패
 */
const authWithLoginHint = async (hint: string): Promise<boolean> => {
    if (!authenticated()) {
        var loginData = {
            username: hint,
            password: "",
        } as LoginActionPayload;
        return store
            .dispatch(types.LOGINHINT, loginData)
            .then((result: account.TCurrent) => {
                if (result.user) {
                    return true;
                } else {
                    throw new Error(`Login failed. Reason`);
                }
            })
            .catch((err) => {
                // TODO: 로그인 실패 페이지로 이동
                console.error(err);
                throw new Error(`Login failed. Reason : ${err}`);
            });
    } else {
        // 이미 로그인 되어 있음
        return true;
    }
};

//
// ────────────────────────────────────────────────────────── I ──────────
//   :::::: F O R   T E A M S : :  :   :    :     :        :          :
// ────────────────────────────────────────────────────────────────────
//

/**
 * Teams 내부에서 동작 중인지 여부
 * @returns true: teams에서 동작 중임, false: 일반 브라우저
 */
const isTeams = () => appbaseStore.state.teams;

/* -------------------- dsmobile js에 의존적이지 않은 모바일 디바이스 체크 ------------------- */

(window as any).mobileAndTabletCheck = function () {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || (window as any).opera);
    return check;
};

/**
 * 팀즈 SDK를 이용하여 로그인된 사용자의 Email 주소를 획득합니다.
 * @returns email address
 */
const getLoginHintFromTeams = () => {
    return new Promise<string>((resolve, reject) => {
        msTeams.getContext((context: any) => {
            if (context?.loginHint) {
                resolve(context.loginHint);
            } else {
                reject("Cannot get context information from Teams.");
            }
        });
    });
};

const processForTeams = async (
    to: Route,
    from: Route,
    next: NavigationGuardNext<Vue>
) => {
    const hint = await getLoginHintFromTeams();
    // 암호 없이 이메일 주소만을 이용하여 인증을 수행합니다.
    if (hint && (await authWithLoginHint(hint))) {
        next();
    } else {
        // TODO: Teams 초기화 실패 페이지로 이동
        throw new Error("An error occurred while initializing Teams.");
    }
};

//
// ──────────────────────────────────────────────────── I ──────────
//   :::::: P U B L I C : :  :   :    :     :        :          :
// ──────────────────────────────────────────────────────────────
//

/**
 * 로그인을 위한 라우트를 재설정합니다.
 * @param to
 * @param from
 * @param next
 */
const resetRouteForLogin = async (
    to: Route,
    from: Route,
    next: NavigationGuardNext<Vue>
) => {
    const { search } = window.location;
    // 웹앱이 Teams 안에서 구동되는 경우
    if (isTeams()) {
        await processForTeams(to, from, next);
    }
    // 웹앱이 브라우저에서 구동되는 경우
    else {
        const useWindowsAuth = false; // 윈도우 인증 사용여부

        // 2022.12.06 현재 인사동기화 처리 되어 있지 않아서 비활성화
        const useADFSAuth = true; // AD FS 인증 사용여부

        //app이면 applogin=1 쿼리 추가

        // 여기서 분기처리 windows 인증 사용여부에 따라 EWA REDRIECT
        // Config 정보가 사용자  정보와 같이 전달되기 때문에 로그인전에는 Crrent == null
        // 웹 서버에 배포된 환경에서만 윈도우즈 인증을 지원
        if (process.env.NODE_ENV === "production" && useWindowsAuth) {
            const url = `${window.location.origin}/ewa`;
            const baseUrl = process.env.BASE_URL!.slice(0, -1); // '/po/'에서 마지막 '/' 제거
            let returnUrl = encodeURIComponent(`${baseUrl}${to.path}${search}`);

            window.location.href = `${url}?returnUrl=${returnUrl}`;
        }
        // AD FS 인증 시 사용
        else if (process.env.NODE_ENV === "production" && useADFSAuth) {

            const url = `${window.location.origin}/cm/common/adfs/api`;
            const baseUrl = process.env.BASE_URL!.slice(0, -1);
            let returnUrl = encodeURIComponent(`${baseUrl}${to.path}${search}`);

            window.location.href = `${url}?returnUrl=${returnUrl}`;
        }
        // 코딩 타임이나 윈도우즈 인증을 사용하지 않은 경우에는 로그인 페이지로 이동
        else {
            const routeName = BYPASS_NAMES[0];
            var mQuery: any = {
                returnUrl: `${to.path}${search}`,
            }
            next({
                name: routeName,
                query: {
                    returnUrl: `${to.path}${search}`,
                },
            });
        }
    }
};

/**
 * 인증 상태를 확인하고 인증이 필요한 경우 라우트를 재 설정합니다.
 * @param to
 * @param from
 * @param next
 * @returns
 */
const authGuard: NavigationGuard = async (to, from, next) => {
    // ────────────────────────────────────────────────────────────────────────────────
    // 이미 로그인 되어 있거나 로그인 페이지로 향하는 경우 가드 통과
    if (BYPASS_NAMES.includes(to.name || "") || authenticated()) {
        console.log(
            "auth-guard",
            "route to : ",
            to.name,
            BYPASS_NAMES.includes(to.name || "")
        );


        if(accessable(to)) {
            next();
        } else {
            next({ name: 'not-authorized' })
        }   
    }
    // ────────────────────────────────────────────────────────────────────────────────
    // 로그인 처리 위한 라우트 재지정
    else {
        try {
            console.log("auth-guard", "reset route to : ", to.name);
            await store.dispatch(types.CURRENT);
            if (authenticated()) {
                if(accessable(to)) {
                    next();
                } else {
                    next({ name: 'not-authorized' })
                }                
            } else {
                console.error("There is no current.");
                await resetRouteForLogin(to, from, next);
            }
        } catch (err) {
            console.error(err);
            await resetRouteForLogin(to, from, next);
        }
    }
};
export default authGuard;
